import { z } from 'zod';
import { avatarUrlSchema, nameSchema } from '@/utils/schemas';

export const tagScheme = z.object({
  Id: z.number(),
  TagName: nameSchema,
  TagCount: z.number(),
  TagMember: z.array(z.object({ Id: z.number(), Name: nameSchema })),
});

export type Tag = z.infer<typeof tagScheme>;

export const tagMemberScheme = z.object({
  TagId: z.number(),
  MemberId: z.number(),
  NickName: nameSchema,
  HeadImg: avatarUrlSchema,
});

export type TagMember = z.infer<typeof tagMemberScheme>;

export const createdTagScheme = z.object({
  Id: z.number(),
  Name: nameSchema,
});
export type CreatedTag = z.infer<typeof createdTagScheme>;
